export const messages = {
  en: {
    aShopSms: {
      queryCondition: 'Query Conditions',
      shopNamePlaceholder: 'Please enter shop name',
      query: 'Query',
      shopSms: 'Shop SMS',
      shopName: 'Shop Name',
      smsCount: 'SMS Count',
      smsSwitch: 'SMS Switch',
      on: 'On',
      off: 'Off',
      operation: 'Operation',
      edit: 'Edit'
    },
    editAShopSms: {
      edit: 'Edit',
      smsCount: 'SMS Count',
      smsCountPlaceholder: 'Required, please enter SMS count',
      smsSwitch: 'SMS Switch',
      smsSwitchPlaceholder: 'Required, please select SMS switch',
      cancel: 'Cancel',
      save: 'Save',
      shopIdRequired: 'Shop ID is required',
      smsIdRequired: 'SMS ID is required',
      smsCountRequired: 'SMS count is required',
      smsSwitchRequired: 'SMS switch is required',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed',
      on: 'On',
      off: 'Off'
    }
  },
  zh: {
    aShopSms: {
      queryCondition: '查询条件',
      shopNamePlaceholder: '请填写店铺名称',
      query: '查询',
      shopSms: '店铺短信',
      shopName: '店铺名称',
      smsCount: '短信数量',
      smsSwitch: '发送开关',
      on: '开',
      off: '关',
      operation: '操作',
      edit: '修改'
    },
    editAShopSms: {
      edit: '修改',
      smsCount: '短信数量',
      smsCountPlaceholder: '必填，请填写短信数量',
      smsSwitch: '短信开关',
      smsSwitchPlaceholder: '必填，请选择短信开关',
      cancel: '取消',
      save: '保存',
      shopIdRequired: '店铺ID不能为空',
      smsIdRequired: '编号不能为空',
      smsCountRequired: '短信数量不能为空',
      smsSwitchRequired: '短信开关不能为空',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      on: '开',
      off: '关'
    }
  }
}